import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store/store";
import "./plugins/base";
import axios from 'axios';
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
import Vue2Filters from "vue2-filters";
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_APIURL;
Vue.config.productionTip = false;
Vue.config.silent = true;
Vue.use(Vue2Filters);

// Verificar si hay un usuario autenticado al cargar la aplicación
// y cargar sus permisos
const user = JSON.parse(localStorage.getItem("user"));
if (user) {
  // Cargar los permisos del usuario antes de montar la aplicación
  store.commit('session_permisos/actualizar_session_PERMISOS');
}

new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
